import { render } from "./passport.vue?vue&type=template&id=08cbda79&scoped=true"
import script from "./passport.vue?vue&type=script&lang=js"
export * from "./passport.vue?vue&type=script&lang=js"

import "./passport.vue?vue&type=style&index=0&id=08cbda79&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08cbda79"]])

export default __exports__